import { render, staticRenderFns } from "./EventLogWidget.vue?vue&type=template&id=56a66f1f&scoped=true"
import script from "./EventLogWidget.vue?vue&type=script&lang=js"
export * from "./EventLogWidget.vue?vue&type=script&lang=js"
import style0 from "./EventLogWidget.vue?vue&type=style&index=0&id=56a66f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a66f1f",
  null
  
)

export default component.exports